module.exports = __webpack_public_path__ + "assets/f2caef7200a9f9d25a17571b849f3262.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/freespin/2XMulti.mp3
 ** module id = 235
 ** module chunks = 0
 **/